import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {CustomerModel} from '@/libs/Api';
import {CustomersDataService} from '@/libs/customers/customers-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const customersStore = registerCrudStore<CustomerModel, CustomerModel>(BusinessModule.Customer, new CustomersDataService());
